import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useMatch } from "react-router-dom-v5-compat";

import { isValidBoolean } from "seneca-common/utils/functions";

import { isAndroid, isIOS } from "features/common/utils/functions/mobile";
import useShowNotificationsPreferences from "features/dashboard/pages/hooks/useShowNotificationsPreferences";
import fetchPreferencesQueryOptions from "features/notifications/queries";
import { isSchoolStudent } from "features/user";
import { ROUTES } from "routing/routes";

export default function useShowActivateAssignmentNotificationsModal() {
  const isStudent = useSelector(isSchoolStudent);
  const showNotificationsPreferences = useShowNotificationsPreferences();
  const isMobileDevice = isAndroid() || isIOS();

  const isOnDashboard = !!useMatch(ROUTES.DASHBOARD.path);
  const isOnCourseHomepage = !!useMatch(ROUTES.CLASSROOM.COURSE.path);
  const isMatchingLocation = isOnDashboard || isOnCourseHomepage;

  const queryEnabled =
    isStudent &&
    showNotificationsPreferences &&
    isMobileDevice &&
    isMatchingLocation;

  const { isLoading, data: preferences } = useQuery({
    ...fetchPreferencesQueryOptions("push"),
    enabled: queryEnabled,
    staleTime: Infinity
  });

  const showModal =
    queryEnabled &&
    preferences &&
    !(
      isValidBoolean(preferences.assignmentSet) &&
      isValidBoolean(preferences.assignmentDue)
    );

  return { isLoading, showModal };
}
